import axios from "axios";

const BASE = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("auprea_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("auprea_token");
    }
    return Promise.reject(err);
  }
);

export const auth = {
  login: (email, password) => api.post("/auth/login", { email, password }).then(r => r.data),
  me:    () => api.get("/auth/me").then(r => r.data),
  forgot: (email) => api.post("/auth/forgot", { email }).then(r => r.data),
  checkReset: (token) => api.get(`/auth/reset/${token}`).then(r => r.data),
  reset: (token, password) => api.post("/auth/reset", { token, password }).then(r => r.data),
  checkInvitation: (token) => api.get(`/auth/invitation/${token}`).then(r => r.data),
  completeInvitation: (token, password) => api.post("/auth/invitation/complete", { token, password }).then(r => r.data),
  changePassword: (current, newPwd) => api.post("/auth/change-password", { current, new: newPwd }).then(r => r.data),
  updateProfile: (data) => api.put("/auth/profile", data).then(r => r.data),
};

export const conseillersApi = {
  list:   () => api.get("/conseillers").then(r => r.data),
  get:    (id) => api.get(`/conseillers/${id}`).then(r => r.data),
  create: (data) => api.post("/conseillers", data).then(r => r.data),
  update: (id, data) => api.put(`/conseillers/${id}`, data).then(r => r.data),
  remove: (id) => api.delete(`/conseillers/${id}`).then(r => r.data),
  tree:   () => api.get("/network/tree").then(r => r.data),
  pendingInvitations: () => api.get("/admin/invitations").then(r => r.data),
  pendingResets: () => api.get("/admin/password-resets").then(r => r.data),
};

export const leadsApi = {
  list:   () => api.get("/leads").then(r => r.data),
  create: (data) => api.post("/leads", data).then(r => r.data),
  update: (id, data) => api.put(`/leads/${id}`, data).then(r => r.data),
  remove: (id) => api.delete(`/leads/${id}`).then(r => r.data),
};

export const dashboardApi = {
  get: () => api.get("/dashboard").then(r => r.data),
  consultant: (mois) => api.get(`/dashboard/consultant${mois ? `?mois=${mois}` : ""}`).then(r => r.data),
  admin: (mois) => api.get(`/dashboard/admin${mois ? `?mois=${mois}` : ""}`).then(r => r.data),
  funnel: (mois) => api.get(`/dashboard/admin/funnel${mois ? `?mois=${mois}` : ""}`).then(r => r.data),
  consultantsActivity: (mois) => api.get(`/dashboard/admin/consultants${mois ? `?mois=${mois}` : ""}`).then(r => r.data),
  repartition: (mois) => api.get(`/dashboard/admin/repartition${mois ? `?mois=${mois}` : ""}`).then(r => r.data),
  demographie: () => api.get(`/dashboard/admin/demographie`).then(r => r.data),
  alertes: () => api.get(`/dashboard/admin/alertes`).then(r => r.data),
  dossiers: (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v) q.set(k, v); });
    return api.get(`/dashboard/admin/dossiers${q.toString() ? `?${q}` : ""}`).then(r => r.data);
  },
  exportCsvUrl: (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v) q.set(k, v); });
    return `${BASE}/dashboard/admin/dossiers/export-csv${q.toString() ? `?${q}` : ""}`;
  },
};

export const commissionsApi = {
  get: () => api.get("/commissions").then(r => r.data),
};

export default api;
